// extracted by mini-css-extract-plugin
export default {"loader":"OtcChatsPage_loader__DcRev","stripes-animation-background-keyframes":"OtcChatsPage_stripes-animation-background-keyframes__oB6kn"};